import { Checkbox } from "shared";
import {
    ComponentTypes,
    ITemplateComponent,
    ITemplateCounterpartyComponent
} from "entities/template";
import React from "react";
import { useComponentsTranslations } from "../../../../lib/i18n";
import { FieldList } from "../../form_fields/field_list/field_list";
import { VisibilityField } from "../../form_fields/visibility_field/visibility_field";
import { LabelField } from "../../form_fields/label_field/label_field";
import { TooltipField } from "../../form_fields/tooltip_field/tooltip_field";
import styles from "./component_form_counterparty.module.scss";

interface IComponentFormCounterpartyProps {
    component: ITemplateCounterpartyComponent;
    componentList: ITemplateComponent[];
    enLanguageEnabled: boolean;
    triggerValidate: number;
    onChange: (component: ITemplateComponent) => void;
}

export const ComponentFormCounterparty: React.FC<IComponentFormCounterpartyProps> = React.memo(({
                                                                                                    component,
                                                                                                    enLanguageEnabled,
                                                                                                    componentList,
                                                                                                    triggerValidate,
                                                                                                    onChange
                                                                                                }) => {
    const t = useComponentsTranslations();

    const onFieldChange = (value: Partial<ITemplateCounterpartyComponent>) => {
        onChange({
            ...component,
            ...value
        })
    }

    return <div className={styles.container}>
        <div className={styles.description}>{t("counterpartyComponentDescription")}</div>
        <LabelField component={component}
                    enLanguageEnabled={enLanguageEnabled}
                    title={t("formLabel")}
                    name="label-dynamic-input"
                    onChange={onFieldChange}/>
        <FieldList
            type={ComponentTypes.counterparty}
            suffix={component.suffix}
            fieldList={component.fieldsList}
            triggerValidate={triggerValidate}
            required={true}
            showSubLabel={false}
            onChange={onFieldChange}/>
        <VisibilityField
            component={component}
            componentList={componentList}
            onChange={onFieldChange}/>
        <TooltipField
            component={component}
            enLanguageEnabled={enLanguageEnabled}
            onChange={onFieldChange}
        />
        <div className={styles.checkboxGroup}>
            <Checkbox
                label={t("requiredField")}
                size="m"
                onChange={() => onFieldChange({ required: typeof component.required === "boolean" ? !component.required : false })}
                checked={typeof component.required === "boolean" ? component.required : true}
            />
            <Checkbox
                label={t("readonlyField")}
                size="m"
                onChange={() => onFieldChange({ readonly: !component.readonly })}
                checked={component.readonly}
            />
        </div>
        <Checkbox
            className={styles.singleCheckbox}
            label={t("selectOnlyField")}
            size="m"
            onChange={() => onFieldChange({ selectonly: !component.selectonly })}
            checked={component.selectonly}
        />
    </div>;
});
